/**
 * @author Fabio Junior fabiojunior@sagaranatech.com DATE 18/01/2013 Time: 17:20
 *
 * @author Daniel Laurindo daniellaurindo@sagaranatech.com DATE 21/05/2013 Time: 09:59
 */

Monet.Date = Monet.Date || {};

Monet.Date.GeneralFunctions = function() {
  /**
   * @see Testes on DateFunctionsSpec.js
   */
  this.validateDate = function(dateInitial, dateFinal) {
    var monetFormat =
      Monet.I18n.locale.dateFormat.toUpperCase() +
      " " +
      Monet.I18n.locale.timeFormat;
    var timeInitial, timeFinal;

    if (dateInitial !== "" && dateFinal !== "") {
      timeInitial = new Date(moment(dateInitial, monetFormat)._d).getTime();
      timeFinal = new Date(moment(dateFinal, monetFormat)._d).getTime();

      return !(timeFinal < timeInitial);
    }

    return false;
  };

  this.validateDateGreaterOrEqualThan = function(dateInitial, dateFinal) {
    if (dateInitial !== "" && dateFinal !== "") {
      const timeInitial = moment(dateInitial)._d.getTime();
      const timeFinal = moment(dateFinal)._d.getTime();

      return timeFinal >= timeInitial;
    }

    return false;
  };

  this.validateIfDateIsInFuture = function(date) {
    const timeToday = new Date().getTime();
    const timeDate = moment(date)._d.getTime();

    return timeDate > timeToday;
  };

  this.checkIfDateIntervalGreaterThanAllowed = ({ dateInitial, dateFinal, maxRangeInDays }) => {
    const diffDays = moment(dateInitial).diff(moment(dateFinal), 'days');
    const absoluteDiffDays = Math.abs(diffDays);

    return absoluteDiffDays > maxRangeInDays;
  };

  this.checkIfDateIsToday = function(date) {
    var error = null;

    try {
      var timeToday = new Date();
      timeToday = timeToday.setHours(0, 0, 0, 0);
      var timeDate = moment(date)._d.getTime();

      return timeDate === timeToday;
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on check if date is today."
      );
      error.console();
    }
  };

  this.convertTimeToHoursMinutesAndSeconds = function(timeInMilliSeconds) {
    var error = null;

    try {
      var keyHourAbreviation = "Greenmile.UnitMetrics.hourAbreviation",
        keyMinuteAbreviation = "Greenmile.UnitMetrics.minuteAbreviation",
        keySecondsAbreviation = "Greenmile.UnitMetrics.secondsAbreviation",
        timeFormated = "",
        seconds = Math.floor(timeInMilliSeconds / 1000),
        minutes = Math.floor(seconds / 60),
        hour = Math.floor(minutes / 60),
        hourAbreviation = Monet.I18n.getResourcesByKey(keyHourAbreviation),
        minuteAbreviation = Monet.I18n.getResourcesByKey(keyMinuteAbreviation),
        secondAbreviation = Monet.I18n.getResourcesByKey(keySecondsAbreviation);

      if (hour > 0) {
        timeFormated += hour + hourAbreviation + " ";
      }

      timeFormated += (minutes % 60) + minuteAbreviation + " ";

      if (seconds > 0) {
        timeFormated += (seconds % 60) + secondAbreviation;
      }

      return timeFormated;
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on convert miliseconds on hour, minutes and seconds."
      );
      error.console();
    }
  };

  this.endHourIsGreaterOrEqualThanBeginningHour = function(hourBegin, hourEnd) {
    let error = null;
    let timeBegin, timeEnd;
    const timeFormat = Monet.I18n.locale.timeFormat;

    try {
      if (typeof hourBegin !== "undefined" && typeof hourEnd !== "undefined") {
        if (hourBegin !== "" && hourEnd !== "") {
          timeBegin = moment(hourBegin, timeFormat)._d.getTime();
          timeEnd = moment(hourEnd, timeFormat)._d.getTime();

          if (timeEnd >= timeBegin) {
            return true;
          }
        }
      } else {
        error = new Monet.Exception.ReturnError(
          this,
          "Some parameters are undefined on endHourIsGreaterOrEqualThanBeginningHour."
        );
        error.console();
      }

      return false;
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on endHourIsGreaterOrEqualThanBeginningHour."
      );
      error.console();
    }
  };

  this.endHourIsGreaterThanStartHour = function(hourBegin, hourEnd) {
    let error = null;
    let timeBegin, timeEnd;
    const timeFormat = Monet.I18n.locale.timeFormat;

    try {
      if (hourBegin && hourEnd) {
        if (hourBegin !== "" && hourEnd !== "") {
          timeBegin = moment(hourBegin, timeFormat)._d.getTime();
          timeEnd = moment(hourEnd, timeFormat)._d.getTime();

          if (timeEnd > timeBegin) {
            return true;
          }
        }
      } else {
        error = new Monet.Exception.ReturnError(
          this,
          "Some parameters are undefined on endHourIsGreaterThanStartHour."
        );
        error.console();
      }

      return false;
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on endHourIsGreaterThanStartHour."
      );
      error.console();
    }
  };

  this.convertMillisecondsToHoursAndMinutes = function(timeInMilliSeconds) {
    var error = null;

    try {
      if (timeInMilliSeconds > 0) {
        var keyHourAbreviation = "Greenmile.UnitMetrics.hourAbreviation",
          keyMinuteAbreviation = "Greenmile.UnitMetrics.minuteAbreviation",
          timeFormated = "",
          seconds = Math.floor(timeInMilliSeconds / 1000),
          minutes = Math.floor(seconds / 60),
          hour = Math.floor(minutes / 60),
          hourAbreviation = Monet.I18n.getResourcesByKey(keyHourAbreviation),
          minuteAbreviation = Monet.I18n.getResourcesByKey(
            keyMinuteAbreviation
          );

        timeFormated += hour + hourAbreviation + " ";

        timeFormated += (minutes % 60) + minuteAbreviation + " ";

        return timeFormated;
      } else {
        return "";
      }
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on convert miliseconds on hour and minutes."
      );
      error.console();
    }
  };

  this.convertTimeToDaysHoursMinutesAndSeconds = function(timeInMilliSeconds) {
    var error = null;

    try {
      if (timeInMilliSeconds > 0) {
        var keyHourAbreviation = "Greenmile.UnitMetrics.hourAbreviation",
          keyMinuteAbreviation = "Greenmile.UnitMetrics.minuteAbreviation",
          keyDayAbreviation = "Greenmile.UnitMetrics.dayAbreviation",
          timeFormated = "",
          seconds = Math.floor(timeInMilliSeconds / 1000),
          minutes = Math.floor(seconds / 60),
          hour = Math.floor(minutes / 60),
          day = Math.floor(hour / 24),
          hourFinal = 0,
          dayAbreviation = Monet.I18n.getResourcesByKey(keyDayAbreviation),
          hourAbreviation = Monet.I18n.getResourcesByKey(keyHourAbreviation),
          minuteAbreviation = Monet.I18n.getResourcesByKey(
            keyMinuteAbreviation
          );

        if (hour > 24) {
          hourFinal = Math.floor(hour % 24);

          timeFormated +=
            day + dayAbreviation + " " + hourFinal + hourAbreviation + " ";
        } else {
          timeFormated += hour + hourAbreviation + " ";
        }

        timeFormated += (minutes % 60) + minuteAbreviation + " ";

        return timeFormated;
      } else {
        return "";
      }
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on convert miliseconds on hour, minutes and seconds."
      );
      error.console();
    }
  };

  this.convertHourToMilliSeconds = function(hourMinuteSeconds) {
    var milliseconds;
    var seconds = 0;
    var error = null;

    try {
      seconds = new Monet.Format.SECONDS(hourMinuteSeconds)
        .convertHourToSeconds()
        .getValue();

      milliseconds = seconds * 1000;

      return milliseconds;
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on convert hour to milliseconds",
        e
      );
      error.console();
    }
  };

  this.getCurrentDateAndTime = function() {
    return Monet.Format.DateTime.formatToLocale(Monet.Format.DateTime.getTodayISOString());
  };

  this.getTimeFormat = () => (
    Monet.I18n.locale.timeFormat === 'hh:mm a' ? 'hh:mm TT' : Monet.I18n.locale.timeFormat
  );

  this.getTimeFormatWithSeconds = () => (
    Monet.I18n.locale.timeFormat === 'hh:mm a' ? 'hh:mm:ss TT' : Monet.I18n.locale.timeFormat + ':ss'
  );

  this.getAbsoluteTimeFormatWithSeconds = () => {
    const dateFormat = Monet.I18n.locale.timeFormat;
    const parsedDateFormat = String(dateFormat).replace('hh', 'HH');

    return dateFormat === 'hh:mm a' ? 'HH:mm:ss' : `${parsedDateFormat}:ss`
  };

  this.setDateTimePicker = (selector, extraOptions) => {
    let jqueryUiFormat = Monet.I18n.locale.dateFormat.toLowerCase();
    jqueryUiFormat = jqueryUiFormat.replace("yyyy", "yy");

    if (extraOptions && !extraOptions.beforeShow) {
      extraOptions.beforeShow = (input, inst) => {
        inst.dpDiv.css({
          "margin-top": "0px",
          "margin-left": "0px"
        });
      };
    }

    $(selector).datetimepicker({
      hourGrid: 4,
      minuteGrid: 10,
      timeFormat: this.getTimeFormat(),
      dateFormat: jqueryUiFormat,
      ...extraOptions
    });
  };

  this.setTimePicker = (selector, extraOptions, timeFormat) => {
    $(selector).timepicker({
      hourGrid: 4,
      minuteGrid: 10,
      timeFormat: timeFormat || this.getTimeFormat(),
      timeOnlyTitle: Monet.I18n.getResourcesByKey("Greenmile.TimePicker.Title"),
      beforeShow: () => {
        $('main').append($('#ui-datepicker-div'));
      },
      ...extraOptions
    });
  };
};
